import { render, staticRenderFns } from "./ClassDetail.vue?vue&type=template&id=0eafc94d&scoped=true&"
import script from "./ClassDetail.vue?vue&type=script&lang=ts&"
export * from "./ClassDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eafc94d",
  null
  
)

export default component.exports